import React from 'react';
import { observer } from 'mobx-react';
import { Card, Col, Row, List, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useStores } from '@app/hooks/stores';
import useAsyncEffect from '@app/hooks/useAsyncEffect';
import { Can } from '@app/modules/Auth/components';
import { Profile } from '@app/modules/Profiles/Temperature/store';
import ProfileItem from '@app/modules/Profiles/Temperature/components/ProfileItem';

const Profiles: React.FC = () => {
  const { profilesStore } = useStores();

  useAsyncEffect(profilesStore.getProfiles, [profilesStore.listProfiles.length === 0]);

  const addBlankItem = () => {
    // @ts-ignore
    profilesStore.addBlankProfile();
  };

  return (
    <Row gutter={24}>
      <Col lg={24} md={24} sm={24}>
        <Card
          title="Temperature Profiles"
          extra={
            <Can
              action="post:profiles/temperature"
              yes={() => (
                <Button type="link" icon={<PlusOutlined />} onClick={addBlankItem}>
                  Add
                </Button>
              )}
              no={() => null}
            />
          }
        >
          <List
            loading={profilesStore.loading}
            itemLayout="horizontal"
            size="large"
            pagination={false}
            dataSource={profilesStore.listProfiles}
            renderItem={(item: Profile) => <ProfileItem item={item} />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default observer(Profiles);
